import script from "./BaseRadio.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseRadio.vue?vue&type=script&setup=true&lang=js"

import "./BaseRadio.vue?vue&type=style&index=0&id=db5ab42c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db5ab42c"]])

export default __exports__